export const pattern = "^[a-zA-Z][a-zA-Z'\\s\\-]*$";
export default pattern;
